import Vue from "vue";
import Login from "./Login.vue";

export function load() {
    const selector = "login-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(Login, {
        props: {
          ...window[selector]
        }
      })
  }).$mount(selector);
}
